import { Pipe, PipeTransform } from 'angular-ts-decorators';

export interface IContact {
  name?: string;
  email?: string;
  mobile?: string;
}
/**
 * Transform contact object into a human readable string.
 * Patches up missing params in IContact with translated strings of `unknown`
 * @param {IContact} input object with contact information
 * @return {string} contact as a patched up string
 */
@Pipe({ name: 'contact' })
export class ContactPipe implements PipeTransform {
  constructor(private $translate: ng.translate.ITranslateService) {
    'ngInject';
  }

  public transform(input: IContact): string {
    const contact = [];
    if (angular.isObject(input)) {
      if (input.name) {
        contact.push(input.name);
      } else {
        contact.push(this.$translate.instant('core.unknown'));
      }

      if (input.email) {
        contact.push(input.email);
      } else {
        contact.push(this.$translate.instant('core.unknown'));
      }

      if (input.mobile) {
        contact.push(input.mobile);
      } else {
        contact.push(this.$translate.instant('core.unknown'));
      }
      return contact.join(', ');
    } else {
      return this.$translate.instant('core.unknown');
    }
  }
}
